import { Array } from '@common/Array/Array'

import type { TOs } from '../definitions'
import { IOS_OSS } from '../definitions'

/**
 * Ez egy iOS eszköz?
 * @param os - Os típusa.
 */
export default function isIOS (os: TOs): boolean { // eslint-disable-line @typescript-eslint/naming-convention
  return Array.includes(IOS_OSS, os)
}
